import React from "react";
import CompanyName from "./CompanyName";

const HighlightCompanyName = ({ text }) => {
  const companyName = "Belageri Technologies";

  if (!text) {
    return null;
  }

  const parts = text.split(companyName);

  return (
    <span>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {index !== parts.length - 1 && <CompanyName />}
        </React.Fragment>
      ))}
    </span>
  );
};

export default HighlightCompanyName;
